module.exports = __webpack_public_path__ + "img/20a4de865550766e013241a09115bdc1.20556138.jpg";